import { Timesheet } from "domain/entities/timesheet";
import { TimesheetDay } from "domain/entities/timesheet-day";
import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { EventType } from "../use-timesheet-calendar-store";

interface TimesheetFormState {
  currentTimesheetDay: TimesheetDay | undefined;
  currentTimesheet: Timesheet | undefined;
  currentEvents: EventType[] | undefined;
  setCurrentTimesheet: (objectState: Timesheet | undefined) => void;
  setCurrentTimesheetDay: (objectState: TimesheetDay | undefined) => void;
  setCurrentEvents: (currentEvents: EventType[] | undefined) => void;
  resetTimesheetForm: () => void;
  resetCurrentTimesheetDay: () => void;
}

export const useTimesheetFormStore = create<TimesheetFormState>()(
  devtools(
    (set) => ({
      setCurrentTimesheetDay: (objectState: TimesheetDay) =>
        set((state) => ({
          currentTimesheetDay: {
            ...state.currentTimesheetDay,
            ...objectState,
          } as TimesheetDay,
        })),
      setCurrentTimesheet: (objectState: Timesheet) =>
        set((state) => ({
          currentTimesheet: {
            ...state.currentTimesheet,
            ...objectState,
          } as Timesheet,
        })),
      setCurrentEvents: (objectState: EventType[]) =>
        set((state) => ({
          currentEvents: {
            ...state.currentEvents,
            ...objectState,
          } as EventType[],
        })),
      resetCurrentTimesheetDay: () =>
        set({
          currentTimesheetDay: undefined,
        }),
      resetTimesheetForm: () =>
        set({
          currentTimesheetDay: undefined,
          currentTimesheet: undefined,
          currentEvents: [],
        }),
    }),

    { name: "CurrentTimesheetForm" }
  )
);
